import React from 'react';
import PropTypes from 'prop-types';

import { isUndefined } from 'lodash';
import displayName from 'component-lib/displayName';

import { TextLabel } from '../Widgets/Components';
import RetinaImage from '../RetinaImage';

import styles from './EmptyResultsBase.scss';

export default function EmptyResultsBase({ image, name, children, role, isPersonal }) {
    return (
        <section data-field={`empty_results_${name}`} className={isPersonal ? styles.personalWrapper : styles.wrapper}>
            {!isUndefined(image) &&
            <RetinaImage className={!isPersonal ? styles.icon : ''} image={image} role={role} />
            }
            <TextLabel className={styles.text}>
                {children}
            </TextLabel>
        </section>
    );
}

EmptyResultsBase.displayName = displayName('EmptyPageViews/EmptyResultsBase');

EmptyResultsBase.propTypes = {
    image: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    role: PropTypes.string,
    isPersonal: PropTypes.bool,
};

EmptyResultsBase.defaultProps = {
    role: 'presentation',
    isPersonal: false,
};
